import { USER_LOGOUT, UPDATE_APP_DATA } from 'actions/actionTypes';

const initialState = { notification: null, redirectToURL: '', FeatureFlags:{initialData:true} };

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_APP_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}
